import ZipcodeController from './zipcodes_controller'

export default class extends ZipcodeController {
  static targets = ['zipcode', 'street', 'neighborhood', 'city', 'state', 'address']
}
